/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    TableComponent
} from "../../../CommonComponents";
import "../../styles.scss";
import Heading from "../../../../../components/Heading";
import { ReportsService } from "../../../../../services/api/reports";
import { downloadOutscanByHubToBranchReport, downloadInscanByCPReport, downloadInscanByOtherCPReport } from "../../../../../utils/downloadUtils";
import { useRequestCancellation } from "../../../../../hooks/useRequestCancellation";
import { useNavigate, useLocation } from "react-router-dom";
import { showErrorMessage } from "../../../../../utils";

const OutscanByHubToBranch = () => {
    // Global request cancellation hook
    const { createNewRequest, isLatestRequest } = useRequestCancellation();

    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });
    const [reportData, setReportData] = useState([]);

    const [hubUser, setHubUser] = useState();

    const navigate = useNavigate();
    const location = useLocation();
    const { type } = location.state;




    // Set user role
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userinfo"));
        setHubUser(user?.roles?.[0]);
    }, []);


    // Fetch report data
    useEffect(() => {
        if (!hubUser) return;
        if (!location.state) return;
        const { date, fromDate } = location.state;
        const dateValue = date || fromDate;
        if (!dateValue) return;
        fetchReport();
        // eslint-disable-next-line
    }, [hubUser, location.state, pagination.current, pagination.pageSize]);

    const fetchReport = async () => {
        // 🔥 Create new request for cancellation support
        const requestId = createNewRequest();

        setLoading(true);
        let shouldUpdateState = true;

        try {
            // Get form parameters from location.state
            const formParams = location.state || {};
            const { date, fromDate, toDate, fromHubId, toCpId, hubId, deliveryCpId } = formParams;
            // Use date if available, otherwise fall back to fromDate
            const dateValue = date || fromDate;
            if (!dateValue) {
                setLoading(false);
                return;
            }

            setReportData([]);

            const params = {
                date: moment(dateValue).format("YYYY-MM-DD"),
                fromDate: moment(dateValue).format("YYYY-MM-DD"), // For backward compatibility
                ...(fromHubId && { fromHubId }),
                ...(hubId && { fromHubId: hubId }),
                ...(toCpId && { toCpId }),
                ...(deliveryCpId && { toCpId: deliveryCpId }),
                page: (pagination.current - 1),
                size: pagination.pageSize
            };

            let response;
            if (type === "outscanByHubToCp") {
                response = await ReportsService.getOutscanByHubToBranch(params);
            } else if (type === "inscanByOtherCp") {
                response = await ReportsService.getInscanByOtherCP(params);
            } else {
                response = await ReportsService.getInscanByCP(params);
            }
            const { data, total } = response;

            // 🔥 Check if this is still the latest request
            if (!isLatestRequest(requestId.requestId)) {
                shouldUpdateState = false;
            } else {
                setReportData(data || []);
                setPagination(prev => ({
                    ...prev,
                    total: total || 0,
                }));
            }
        } catch (error) {
            console.error("API error:", error);
            // 🔥 Check if this is still the latest request
            if (!isLatestRequest(requestId.requestId)) {
                shouldUpdateState = false;
            } else {
                showErrorMessage("Failed to fetch report data");
                setReportData([]);
                setPagination(prev => ({
                    ...prev,
                    total: 0
                }));
            }
        } finally {
            // 🔥 Check if this is still the latest request
            if (isLatestRequest(requestId.requestId)) {
                setLoading(false);
            }
        }
    };

    const handleTableChange = (newPagination) => {
        setPagination(prev => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize
        }));
    };

    const handleDownload = async () => {
        // Get form parameters from location.state
        const formParams = location.state || {};
        const { date, fromDate, toDate, fromHubId, toCpId, hubId, deliveryCpId, type } = formParams;
        // Use date if available, otherwise fall back to fromDate
        const dateValue = date || fromDate;

        if (!dateValue) {
            showErrorMessage("Form parameters are missing for download");
            return;
        }

        setDownloadLoading(true);
        try {
            const downloadParams = {
                date: moment(dateValue).format("YYYY-MM-DD"),
                fromDate: moment(dateValue).format("YYYY-MM-DD"), // For backward compatibility
                ...(fromHubId && { fromHubId }),
                ...(hubId && { fromHubId: hubId }),
                ...(toCpId && { toCpId }),
                ...(deliveryCpId && { toCpId: deliveryCpId })
            };

            // Use appropriate download function based on report type
            if (type === "outscanByHubToCp") {
                await downloadOutscanByHubToBranchReport(downloadParams);
            } else if (type === "inscanByOtherCp") {
                await downloadInscanByOtherCPReport(downloadParams);
            } else {
                await downloadInscanByCPReport(downloadParams);
            }

            message.success("Report downloaded successfully");
        } catch (error) {
            console.error("Download error:", error);
            message.error("Failed to download report");
        } finally {
            setDownloadLoading(false);
        }
    };

    const handleBack = () => {
        navigate("/outscan-cpinscan");
    };

    // Function to get table columns based on report type
    const getTableColumns = (reportType) => {
        const baseColumns = [
            {
                title: "AWB Number",
                dataIndex: "awbNumber",
                key: "awbNumber",
                sorter: true,
                align: "center",
                width: 150,
                render: (text, record) => (
                    <span
                        style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => {
                            const url = `/shipment-tracker?awb=${text}`;
                            window.open(url, "_blank");
                        }}
                    >
                        {text}
                    </span>
                )
            }
        ];

        // Add date/datetime column based on report type
        if (reportType === "outscanByHubToCp") {
            baseColumns.push({
                title: "Date Time",
                dataIndex: "datetime",
                key: "datetime",
                sorter: true,
                align: "center",
                width: 180,
                render: (text) => text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-"
            });
        } else {
            // For inscanBySameCp and inscanByOtherCp
            baseColumns.push({
                title: "Date",
                dataIndex: "date",
                key: "date",
                sorter: true,
                align: "center",
                width: 120,
                render: (text) => text ? moment(text).format("YYYY-MM-DD") : "-"
            });
        }

        baseColumns.push(
            {
                title: "From Hub",
                dataIndex: "fromHub",
                key: "fromHub",
                sorter: true,
                align: "center",
                width: 150
            },
            {
                title: reportType === "outscanByHubToCp" ? "To CP" : "CP Name",
                dataIndex: reportType === "outscanByHubToCp" ? "toCp" : "cpName",
                key: reportType === "outscanByHubToCp" ? "toCp" : "cpName",
                sorter: true,
                align: "center",
                width: 150
            }
        );

        // Add weight column for inscan reports
        if (reportType === "inscanBySameCp" || reportType === "inscanByOtherCp") {
            baseColumns.push({
                title: "Weight (Kg)",
                dataIndex: "weight",
                key: "weight",
                align: "center",
                width: 100,
                render: (text) => text || "-"
            });
        } else if (reportType === "outscanByHubToCp") {
            baseColumns.push({
                title: "Weight (Kg)",
                dataIndex: "weight",
                key: "weight",
                align: "center",
                width: 100,
                render: (text) => text || "-"
            });
        }

        return baseColumns;
    };

    return (
        <div className="report-container">
            <div style={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "8px" }}>
                <Heading
                    title={
                        type === "outscanByHubToCp"
                            ? "Outscan By Hub To CP Report"
                            : type === "inscanBySameCp"
                                ? "Inscan By Same CP Report"
                                : type === "inscanByOtherCp"
                                    ? "Inscan By Other CP Report"
                                    : "Inscan By CP Report"
                    }
                    navigateTo="/outscan-cpinscan"
                    showBackButton={true}
                    onBackClick={handleBack}
                >
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        loading={downloadLoading}
                        onClick={handleDownload}
                    >
                        Download Report
                    </Button>
                </Heading>
            </div>
            <TableComponent
                columns={getTableColumns(type)}
                dataSource={reportData}
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey={(record, index) => record.awbNumber || record.id || record.awb || index}
                style={{ marginTop: 32 }}
            />
        </div>
    );
};

export default OutscanByHubToBranch;
